/**
 * MSH ticker — mobile static message + tap-arrow cycling.
 *
 * Desktop (>=750px) keeps the existing CSS-driven auto-scroll marquee
 * untouched; this only drives the mobile static+arrows variant, which is
 * shown/hidden purely by CSS media query in sections/msh-ticker.liquid. The
 * message list is read from the same section.blocks data already used by
 * the marquee (rendered into a hidden <ul data-msh-ticker-list>), so there
 * is a single source of truth for ticker copy.
 */
(function () {
  function initTicker(root) {
    var listItems = root.querySelectorAll('[data-msh-ticker-list] li');
    var textEl = root.querySelector('[data-msh-ticker-text]');
    var prevBtn = root.querySelector('[data-msh-ticker-prev]');
    var nextBtn = root.querySelector('[data-msh-ticker-next]');
    if (!listItems.length || !textEl || !prevBtn || !nextBtn) return;
    if (root.dataset.mshTickerInitialized === 'true') return;
    root.dataset.mshTickerInitialized = 'true';

    var messages = Array.prototype.map.call(listItems, function (li) {
      return li.textContent.trim();
    });

    var index = 0;
    function show(i) {
      index = (i + messages.length) % messages.length;
      textEl.textContent = messages[index];
    }

    show(0);

    prevBtn.addEventListener('click', function () {
      show(index - 1);
    });
    nextBtn.addEventListener('click', function () {
      show(index + 1);
    });
  }

  function initAll() {
    document.querySelectorAll('.msh-ticker').forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
